import { useEffect, useState } from 'react';

// Hash routing keeps deep links working behind Access with no server rewrites: #/campaigns/SI.EML.PSPCT.26.001
export type Route = { path: string; parts: string[]; query: Record<string, string> };

const parse = (): Route => {
  const hash = location.hash.replace(/^#/, '') || '/';
  const [path, q] = hash.split('?');
  return { path, parts: path.split('/').filter(Boolean).map(decodeURIComponent), query: Object.fromEntries(new URLSearchParams(q || '')) };
};

export function useRoute() {
  const [route, setRoute] = useState(parse);
  useEffect(() => {
    const on = () => { setRoute(parse()); window.scrollTo(0, 0); };
    window.addEventListener('hashchange', on);
    return () => window.removeEventListener('hashchange', on);
  }, []);
  return route;
}

export const go = (hash: string) => { location.hash = hash; };
export const withQuery = (base: string, form: HTMLFormElement) => {
  const p = new URLSearchParams();
  for (const [k, v] of new FormData(form).entries()) if (v) p.set(k, String(v));
  const s = p.toString();
  return s ? `${base}?${s}` : base;
};
